import { createRoot } from 'react-dom/client';
import { setVeauryOptions } from 'veaury';

// Configure veaury for React 18/19 compatibility before any other imports.
// MUST be synchronous: variant-entry.js imports this at the top, then
// imports variant Home components which call applyPureReactInVue at
// import time — if Veaury isn't configured yet, React mount fails
// silently and the page renders blank.
//
// SSR-safety: this file is ONLY imported by client entries (app.js,
// variant-entry.js). The SSR entry (resources/js/ssr.js) wires
// setVeauryOptions({ react: { renderToString } }) from react-dom/server
// independently before any component imports. So no `typeof window`
// guard needed here.
setVeauryOptions({
    react: {
        createRoot,
    },
});
